import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddQuizMutation } from "../../../features/Quiz/quizApi";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import routes from "../../../config/routeConfig";
import QuizForm from "./QuizForm";

const initialOptions = [
  { id: 1, option: "", isCorrect: true },
  { id: 2, option: "", isCorrect: false },
  { id: 3, option: "", isCorrect: false },
  { id: 4, option: "", isCorrect: false },
];

export default function AddQuizForm() {
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [options, setOptions] = useState(initialOptions);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const { data: videos } = useGetVideosQuery();

  const [addQuiz, { isSuccess, isError, error }] = useAddQuizMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    const resultBody = {
      question: `${question}?`,
      video_id: selectedVideo.id,
      video_title: selectedVideo.title,
      options,
    };

    addQuiz(resultBody);
  };

  useEffect(() => {
    if (isSuccess) {
      setQuestion("");
      setOptions(initialOptions);
      navigate(routes.admin.quiz, { replace: true });
    } else if (isError) {
      alert(error?.data);
    }
  }, [isError, isSuccess]);

  return (
    <QuizForm
      handleSubmit={handleSubmit}
      question={question}
      setQuestion={setQuestion}
      options={options}
      setOptions={setOptions}
      setSelectedVideo={setSelectedVideo}
      selectedVideo={selectedVideo}
      videos={videos}
    />
  );
}
